<template>
  <div class="route-and-print">
    <template
      v-if="useRoute"
    >
      <router-link
        v-if="checkPermission && !directMode && list.length <= 1"
        :to="fullPath"
        tag="a"
        style="color:#0000FF;"
        @click.native="onClick()"
      >{{ data[field] }}</router-link>
      <template v-else-if="checkPermission && !directMode && list.length >= 2">
        <router-link
          v-for="(item,index) in list"
          :key="item.uuid"
          :to="fullPath"
          tag="a"
          style="color:#0000FF;"
          @click.native="onClick(item)"
        >
          {{ item[field] }}<span v-if="index < list.length-1">,</span>
        </router-link>
      </template>
      <el-link v-else-if="directMode" :href="directFinalUrl" target="_blank">{{ data[field] }}</el-link>
      <el-link v-else type="primary" style="font-size:12px;color:#0000FF;" @click="showMessage">{{ data[field] }}</el-link>
    </template>
    <span v-else>{{ data[field] }}</span>
    <i
      v-if="usePrint"
      class="el-icon-search"
      style="margin-left:5px;color:#0000FF;cursor:pointer"
      @click="printMethod"
    />
    <label style="color: #0000FF;font-weight: normal">{{ shortContent }}</label>
  </div>
</template>
<script>
import lodash from 'lodash'
import { matchView, refreshView } from '@/store/modules/tagsView'
import { INSTRUCTION_ACTION_SINGLE } from '@/class/cargo/model/parameters/SystemConstants'
export default {
  name: 'RouterAndPrint',
  props: {
    // 是否开启路由
    useRoute: {
      type: Boolean,
      default: () => true
    },
    // 是否开启打印
    usePrint: {
      type: Boolean,
      default: () => true
    },
    // 行数据
    data: {
      type: Object,
      default: () => ({})
    },
    // 列key
    field: {
      type: String,
      default: () => ''
    },
    // 跳转路由名称
    routeName: {
      type: String,
      default: () => ''
    },
    // 页面名称
    routeTitle: {
      type: String,
      default: () => ''
    },
    // 路由模式参数key
    routeParamKeys: {
      type: Object,
      default: () => ({})
    },
    // 路由权限
    routePermissions: {
      type: Array,
      default: () => ([])
    },
    // 路由额外参数
    extraRouteParams: {
      type: Object,
      default: () => ({})
    },
    // 路由额外数据
    extraRouteData: {
      type: Object,
      default: () => ({})
    },
    // 路由模式true:vue-router false:链接跳转
    directMode: {
      type: Boolean,
      default: () => false
    },
    // 跳转链接
    directUrl: {
      type: String,
      default: () => ''
    },
    // 链接跳转参数
    directParams: {
      type: Object,
      default: () => null
    },
    // 打印回调
    printMethod: {
      type: Function,
      default: () => {}
    },
    // 可点击项后追加不可点击内容
    shortContent: {
      type: String,
      default: () => ''
    },
    // 跳转指令
    jumpInstruction: {
      type: Object,
      default: () => null
    },
    // 跳转函数
    instructionClick: {
      type: Function,
      required: false,
      default: null
    }
  },
  data() {
    return {
      fullPath: this.$route.fullPath,
      list: []
    }
  },
  computed: {
    routeParams() {
      if (!this.directMode) {
        const params = {}
        Object.keys(this.routeParamKeys).forEach((key) => {
          params[key] = this.data[this.routeParamKeys[key]]
        })
        return {
          ...params,
          ...this.extraRouteParams,
          currentOfficeId: this.$store.getters.currentOfficeId
        }
      }
      return null
    },
    directFinalUrl() {
      const { directMode, directParams, directUrl } = this
      if (directMode) {
        if (directParams) {
          let params = '?'
          Object.keys(directParams).forEach(key => {
            params += `&${key}=${directParams[key]}`
          })
          return directUrl + params
        }
        return directUrl
      }
      return ''
    },
    checkPermission() {
      return this.$checkPermission(this.routePermissions)
    }
  },
  created() {
    if (this.data) {
      if (this.data.jobNo) {
        const arry = this.data.jobNo.split(',')
        if (arry.length > 1) {
          for (let i = 0; i < arry.length; i++) {
            const temp = lodash.cloneDeep(this.data)
            temp['jobNo'] = arry[i]
            this.list.push(temp)
          }
        }
      }
    }
  },
  methods: {
    showMessage() {
      const { routeTitle } = this
      this.$message.error(this.$t('Message.YouToOpenTheModule', [routeTitle]))
    },
    routeParam(item) {
      if (!this.directMode) {
        const params = {}
        Object.keys(this.routeParamKeys).forEach((key) => {
          params[key] = item[this.routeParamKeys[key]]
        })
        return {
          ...params,
          ...this.extraRouteParams,
          currentOfficeId: this.$store.getters.currentOfficeId
        }
      }
      return null
    },
    onClick(item) {
      if (this.jumpInstruction) {
        this.instructionClick(this.jumpInstruction, [this.data], INSTRUCTION_ACTION_SINGLE.code)
        return
      }
      this.$emit('linkClick')
      const location = { name: this.routeName, params: { ...this.extraRouteData }}
      if (item) {
        location.query = this.routeParam(item)
        this.matchOneFromJobNos(location, item)
      } else {
        location.query = this.routeParams
      }
      const oldRoute = this.$route
      this.$router.push(location)
      setTimeout(() => {
        // 路由无变化，手动刷新
        if (location.name === oldRoute.name && this.$route === oldRoute) {
          const view = this.$store.state.tagsView.visitedViews.find(v => matchView(v, this.$route))
          Object.assign(view.params, this.extraRouteData)
          refreshView(view)
        }
      }, 100)
    },
    // 从多个job中，匹配其中一个
    matchOneFromJobNos(location, item) {
      const { query, params } = location
      const jobNo = item.jobNo
      if (query && query.jobNo && query.jobNo !== jobNo && query.jobNo.indexOf(jobNo) > -1) {
        location.query = { ...query, jobNo }
      }
      if (params && params.jobNo && params.jobNo !== jobNo && params.jobNo.indexOf(jobNo) > -1) {
        location.params = { ...params, jobNo }
      }
    }
  }
}
</script>
<style lang="scss">
.route-and-print{
  .el-link {
    font-size:12px;
    &.el-link--default {
      color: rgb(0, 82, 204);
      &:hover {
        color:rgb(0, 82, 204)
      }
    }
  }
}
</style>
